import PropTypes from 'prop-types'
import React from 'react'
import { Tags } from './styles'

function CharacteristicTags({ enumData, values }) {
  const list = [...(values || [])].sort((a, b) => enumData.t(a).localeCompare(enumData.t(b)))

  if (!list.length) return <div className="text-muted text-small">Não informado</div>

  return (
    <Tags>
      {
        list.map((item) => (
          <span className="chip" key={item}>
            {enumData.t(item)}
          </span>
        ))
      }
    </Tags>
  )
}

CharacteristicTags.propTypes = {
  enumData: PropTypes.objectOf(PropTypes.any).isRequired,
  values: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
}

CharacteristicTags.defaultProps = {
  values: [],
}

export default CharacteristicTags
